export const selectAllCotizaciones = ({ CotizacionesSlice: oState }) => oState?.aCotizaciones;
export const selectStatusCotizaciones = ({ CotizacionesSlice: oState }) => oState?.bStatus;
export const selectCotizacionCotizaciones = ({ CotizacionesSlice: oState }) => oState?.oCotizacion;
